import { render, staticRenderFns } from "./hbSetting.vue?vue&type=template&id=e4cdd5b0&scoped=true&"
import script from "./hbSetting.vue?vue&type=script&lang=js&"
export * from "./hbSetting.vue?vue&type=script&lang=js&"
import style0 from "./hbSetting.vue?vue&type=style&index=0&id=e4cdd5b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4cdd5b0",
  null
  
)

export default component.exports